import Vue from "vue";
import UserTransformer from "@/transformers/extranet/users";

/**
 * @author José Luis R
 */

const fetchTaggableUsers = () => {
  return Vue.$http
    .get(`user/basic/list/`)
    .then(({ data }) =>
      UserTransformer.fetchCollection(data).sort((a, b) =>
        a.fullName < b.fullName ? -1 : 1
      )
    )
    .catch((err) => {
      throw err;
    });
};

export default fetchTaggableUsers;



// WEBPACK FOOTER //
// ./src/services/extranet/fetchTaggableUsers.js